<template lang="pug">
#android-homescreen-modal.modal.fade.android-homescreen-modal(v-if="false" tabindex='-1' role='dialog' aria-labelledby='android-homescreen-modal' aria-hidden='true')
  .modal-dialog.modal-dialog-centered(role='document')
    .modal-content
      .modal-body
        .title {{ $t("ui.add_homescreen") }}
        .d-flex.align-items-center.mt-4
          template(v-if="brand == 'IBCBET'")
            img.icon(src='https://r.myw0011001.com/mobile/landing/app_icon_ibcbet.svg')
            .flex-grow-1
              .title {{ brand }}
              .small-text ibcbet.com
          template(v-else-if="brand == 'UBETT'")
            img.icon(src='https://r.myw0011001.com/mobile/landing/app_icon_ub.svg')
            .flex-grow-1
              .title {{ brand }}
              .small-text ubett.bet
          template(v-else)
            img.icon(src='https://r.myw0011001.com/mobile/landing/app_icon.svg')
            .flex-grow-1
              .title {{ brand }}
              .small-text mywbet.com
        .link-wrapper.d-flex.justify-content-end
          .mr-4(data-dismiss='modal' aria-label='Close' @click="close(0)") {{ $t("ui.cancel") }}
          #addHomescreen {{ $t("ui.add") }}
#ios-homescreen-modal.modal.fade.ios-homescreen-modal(v-else tabindex='-1' role='dialog' aria-labelledby='ios-homescreen-modal' aria-hidden='true')
  .close(data-dismiss='modal' aria-label='Close' @click="close(1)")
    i.fal.fa-times
  .modal-dialog(role='document')
    .modal-content
      //- iframe.video(src='https://r.myw0011001.com/mobile/landing/wbet_tutorial.mp4' frameborder='0' allow='accelerometer; encrypted-media; gyroscope; picture-in-picture' allowfullscreen)
      //- <iframe width="300" height="550" src="https://www.youtube.com/embed/KwnzKmtWpIA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      video.video(poster='images/ios_tutorial_poster.jpg' controls='' playsinline='')
        source(src='https://wbhighlight.com/WBET%20app%20download%20tutorial%201121.mp4' type='video/mp4')
</template>

<script>
export default {
  computed: {
    brand() {
      return config.brand;
    }
  },
  methods: {
    close(e) {
      switch(e) {
        case 0:
          $("#android-homescreen-modal").modal("hide");
          break;
        case 1:
          $("#ios-homescreen-modal").modal("hide");
          break;
      }
    }
  }
}
</script>